export default __webpack_public_path__ + "static/media/eye.641cc477.svg";